import React from 'react'
import { MaterialCommunityIcons } from '@expo/vector-icons'
import { useAuth, useMediaQueries, useTheme, useThemeClient } from '@/presentation/hooks'
import { Box, Button, ChipFilter, dateAdapterAtom, HStack } from '@/presentation/components'
import { isOpenServiceOrdersFiltersState, serviceOrdersFiltersState } from '@/presentation/pages/ServiceOrders/components'
import { useRecoilValue, useSetRecoilState } from 'recoil'

type FiltersChipPanelProps = {
  handleAddNewOs: () => void
}

export const FiltersChipPanel: React.FC<FiltersChipPanelProps> = (props) => {
  const theme = useTheme()
  const { getAccentColor } = useThemeClient()
  const dateAdapter = useRecoilValue(dateAdapterAtom)
  const { isMobile } = useMediaQueries()
  const setOpen = useSetRecoilState(isOpenServiceOrdersFiltersState)
  const filters = useRecoilValue(serviceOrdersFiltersState)
  const { getClient } = useAuth()

  const { codTecnico, osSemTecnico } = getClient()

  const period = dateAdapter.format(filters.dataInicio, 'DD/MM/YYYY') +
    ' até ' +
    dateAdapter.format(filters.dataFim, 'DD/MM/YYYY')

  const situation = {
    Todas: 'Todas',
    'Em Aberto': isMobile ? 'Abertas' : 'Somente Abertas',
    Fechadas: isMobile ? 'Fechadas' : 'Somente Fechadas'
  }[filters.situacao]

  return (
    <HStack spacing={6} mb={18} wrap>
      <Box>
        <ChipFilter
          title='Período'
          subtitle={period}
          onPress={() => setOpen(true)}
        />
      </Box>
      <Box>
        <ChipFilter
          title='Status'
          subtitle={situation}
          onPress={() => setOpen(true)}
          />
      </Box>
      <HStack>
        {!isMobile &&
          <Button
            leading={<MaterialCommunityIcons color={theme.colors.white} size={18} name='plus' />}
            disabled={codTecnico === 0 && !osSemTecnico }
            title='Abrir Ordem de Serviço'
            testID='cadastrar-os'
            color={getAccentColor()}
            tintColor={theme.colors.white}
            onPress={props.handleAddNewOs}
          />
        }
      </HStack>
    </HStack>
  )
}
